import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebase";

export function listenToGarmentById(
  garmentId,
  onSuccess,
  onError
) {
  if (!garmentId) {
    onSuccess(null);
    return () => {};
  }

  return onSnapshot(
    doc(db, "garments", garmentId),
    (snapshot) => {
      if (!snapshot.exists()) {
        onSuccess(null);
        return;
      }

      onSuccess({
        id: snapshot.id,
        ...snapshot.data(),
      });
    },
    onError
  );
}
